// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import tr from "./locales/tr.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    lng: localStorage.getItem("i18nextLng") || "tr", // 🔥 kullanıcı dil tercihini koru
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React zaten XSS'e karşı güvenli
    },
    detection: {
      order: ['localStorage', 'navigator'], // eğer language detector eklersen
      caches: ['localStorage'],
    },
  });

export default i18n;
